import styled from 'styled-components'

export default styled.footer`
	position: absolute;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 20px;
	background-color: white;
	color: silver;
	text-align: center;
`



// WEBPACK FOOTER //
// ./src/primitives/Footer.js